<template>
  <div>
    <v-card class="d-flex mb-3" column>
      <v-layout column>
        <v-layout column class="d-flex pa-5">
          <v-layout justify-space-between align-center row>
            <h4
              class="subheading font-weight-bold font-weight-light primary--text mb-3"
            >
              Extrato pormenorizado de reajuste
            </h4>
          </v-layout>
          <v-layout
            justify-space-between
            align-center
            row
            v-if="parametroMensagem"
          >
            <h2 class="subheading font-weight-light mb-3">
              {{ parametroMensagem }}
            </h2>
          </v-layout>
        </v-layout>
        <v-layout class="d-flex pb-5">
          <v-data-table
            hide-actions
            no-data-text="Não há registros"
            :headers="headers"
            :items="rows"
            :loading="isLoading"
          >
            <template v-slot:items="props">
              <td>{{ props.item.competencia }}</td>
              <td>{{ props.item.tipo }}</td>
              <td>
                <v-btn
                  flat
                  small
                  color="primary"
                  @click="
                    baixarExtratoPormenorizado(
                      props.item.competencia,
                      props.item.tipo
                    )
                  "
                  >Baixar</v-btn
                >
              </td>
            </template>
          </v-data-table>
        </v-layout>
      </v-layout>
    </v-card>

    <v-card class="d-flex" column>
      <v-layout column>
        <v-layout column class="d-flex pa-5">
          <v-layout justify-space-between align-center row>
            <h4
              class="subheading font-weight-bold font-weight-light primary--text mb-3"
            >
              Reajuste definitivo
            </h4>
          </v-layout>
        </v-layout>
        <v-layout class="d-flex pb-5">
          <v-data-table
            hide-actions
            no-data-text="Não há registros"
            :headers="headersReajuste"
            :items="rowsReajuste"
            :loading="isLoadingReajuste"
          >
            <template v-slot:items="props">
              <td>{{ props.item.periodo }}</td>
              <td>{{ props.item.percentual }}%</td>
              <td>{{ props.item.motivoReajuste }}</td>
            </template>
          </v-data-table>
        </v-layout>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import { PARAMETROS } from "@/constants";
import {
  downloadExtratos,
  getExtratosPormenorizado,
  getParametro,
  getReajusteDefinitivo
} from "@/services/beneficiario";
import { download } from "@/utils/download";

const { mapMutations } = createNamespacedHelpers("portal");

export default {
  name: "ExtratoPormenorizadoGrid",
  props: {
    dadosBeneficiario: Object
  },
  data() {
    return {
      codigoContrato: null,
      codigoEmpresa: null,
      isLoading: false,
      isLoadingReajuste: false,
      parametroMensagem: null,
      rows: [],
      rowsReajuste: [],
      headers: [
        { sortable: false, text: "Competência", value: "competencia" },
        { sortable: false, text: "Tipo Documento", value: "tipoDocumento" },
        { sortable: false, text: "Anexo", value: "baixar" }
      ],
      headersReajuste: [
        { sortable: false, text: "Competência", value: "periodo" },
        { sortable: false, text: "Percentual", value: "percentual" },
        { sortable: false, text: "Motivação", value: "motivoReajuste" }
      ]
    };
  },
  computed: {
    codigoBeneficiario() {
      return this.dadosBeneficiario.id;
    }
  },
  watch: {
    codigoBeneficiario: {
      handler() {
        this.codigoContrato = this.dadosBeneficiario.contratoId;
        this.codigoEmpresa = this.dadosBeneficiario.empresaId;

        this.gridExtratosPormenorizado();
        this.carregaReajusteDefinitivo();
      }
    }
  },
  async created() {
    this.codigoContrato = this.dadosBeneficiario.contratoId;
    this.codigoEmpresa = this.dadosBeneficiario.empresaId;

    this.parametroMensagem = await getParametro(
      PARAMETROS.MENSAGEM_EXTRATO_PORMENORIZADO
    );

    await Promise.all([
      this.gridExtratosPormenorizado(),
      this.carregaReajusteDefinitivo()
    ]);
  },
  methods: {
    ...mapMutations(["setErrorToast", "setToast"]),
    baixarExtratoPormenorizado(competencia, tipo) {
      this.isLoading = true;

      const payload = {
        codigoEmpresa: this.codigoEmpresa,
        codigoContrato: this.codigoContrato,
        competencia,
        tipo
      };

      downloadExtratos(payload)
        .then(({ headers, data }) => {
          if (data?.error) {
            const errorMessage = data.message;

            this.setErrorToast(errorMessage);
          } else {
            const filename = headers["content-disposition"].replace(
              "attachment; filename=",
              ""
            );

            download(data, filename);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async carregaReajusteDefinitivo() {
      this.isLoadingReajuste = true;

      return getReajusteDefinitivo(this.codigoBeneficiario)
        .then(reajustes => {
          this.rowsReajuste = reajustes;
        })
        .catch(() => {
          this.rowsReajuste = [];
        })
        .finally(() => {
          this.isLoadingReajuste = false;
        });
    },
    async gridExtratosPormenorizado() {
      this.isLoading = true;

      const payload = {
        codigoEmpresa: this.codigoEmpresa,
        codigoContrato: this.codigoContrato
      };

      return getExtratosPormenorizado(payload)
        .then(({ data, extratos, msg_erro }) => {
          if (data?.error) {
            const errorMessage = data.message;

            this.setErrorToast(errorMessage);
          } else {
            if (msg_erro !== null && msg_erro.length) {
              this.setToast(
                `Não foi encontrado extrato pormenorizado para empresa ${
                  this.codigoEmpresa
                }, contrato ${this.codigoContrato}.`
              );
            } else {
              this.rows = extratos;
            }
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
